
// import React from 'react';
// import { FiPhone } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import FrontImage from "../../../src/Components/assets/frontpic.png"

// const HeroSection = () => {
//   const navigate = useNavigate();

//   const handleSignupClick = () => {
//     // Navigate to login page with a query parameter for signup mode
//     navigate("/login?mode=signup");
//   };

//   return (
//     <>
//       <section className="relative h-auto bg-white overflow-hidden">
//         {/* Background Animation Elements */}
//         <div className="absolute inset-0">
//           {/* Grid pattern overlay */}
//           <div className="absolute inset-0 bg-grid-gray-200 bg-[size:60px_60px]"></div>

//           {/* Animated gradient overlay */}
//           <div className="absolute inset-0 bg-gradient-to-r from-blue-50/40 via-transparent to-purple-50/40 animate-gradient-x"></div>
//         </div>

//         {/* Content Container */}
//         <div className="relative z-10  px-10 py-16 lg:py-20">
//           <div className="flex flex-col lg:flex-row items-center justify-between">

//             {/* Left Side - Text Content */}
//             <div className="lg:w-1/2 mb-12 lg:mb-0 text-center lg:text-left">
//               <div className="space-y-3">
//                 <div className="bg-orange-50 border-l-4 border-[#F46653] px-5 py-2 rounded-r-lg w-max shadow-sm">
//                   <p className="text-[#F46653] text-base font-bold">
//                     Looking for Bulk SMS?
//                   </p>
//                 </div>

//                 {/* Main Heading */}
//                 <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight">
//                   <span className="animate-slide-in-left">Signup & Test Bulk SMS Service For Free</span>
//                 </h1>

//                 {/* Description */}
//                 <p className="text-xl text-gray-700 max-w-2xl leading-relaxed animate-fade-in-up">
//                   Reach millions of customers instantly with our reliable bulk SMS platform.
//                   High delivery rates, real-time analytics, and competitive pricing for businesses of all sizes.
//                 </p>



//                 {/* Added Heading from Image */}
//                 <div className="pt-6 animate-fade-in-up">

//                   <div className="border-l-2 border-[#2372AB] pl-3">
//                     <p className="text-[18px] lg:text-[16px] text-black-900 mb-2">
//                       Test our Bulk SMS Service
//                     </p>

//                     {/* <p className="text-lg lg:text-[24px] text-[#F46653] font-semibold mb-4">
//                       Free ₹50 Credit After Signup
//                     </p> */}
//                   </div>


//                   <div className="flex flex-col sm:flex-row gap-8 mt-12">
//                     <button 
//                       onClick={handleSignupClick}
//                       className="px-6 py-4 bg-[#0C4550] text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
//                     >
//                       <span>Signup Now</span>
//                     </button>
//                     <div className="flex items-start space-x-3">
//                       <FiPhone className="text-gray-800 text-[26px] mt-3" />


//                       <div className="flex flex-col">
//                         <span className="text-gray-800 font-medium">For Sales Query</span>

//                         <a
//                           href="tel:+918385035000"
//                           className="text-[#0C4550] font-lg transition-colors duration-300"
//                         >
//                           +91-9717055088
//                         </a>
//                       </div>
//                     </div>



//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Right Side - Image/Visual Content */}
//             <div className="lg:w-1/2 flex justify-center ">
//               <div className="relative">
//                 <div>
//                   <img src={FrontImage}
//                     className=' rounded'
//                     alt="Front" // Added alt tag for accessibility
//                   />
//                 </div>
//                 {/* Background Glow */}
//                 <div className="absolute inset-0  rounded-2xl blur-xl -z-10 opacity-60"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default HeroSection;




// import React from "react";
// import { FiPhone } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import FrontImage from "../../../src/Components/assets/frontpic.png";

// const HeroSection = () => {
//   const navigate = useNavigate();

//   const handleSignupClick = () => {
//     navigate("/login?mode=signup");
//   };

//   return (
//     <section className="relative min-h-[90vh] w-full overflow-hidden flex items-center">
      
//       {/* ===== Background Image ===== */}
//       <div className="absolute inset-0 -z-20">
//         <img
//           src={FrontImage}
//           alt="Bulk SMS Platform Background"
//           className="w-full h-full object-cover scale-110 "
//         />
//       </div>

//       {/* ===== Dark Overlay ===== */}
//       <div className="absolute inset-0 bg-black/55 -z-10"></div>

//       {/* ===== Gradient Overlay ===== */}
//       <div className="absolute inset-0 bg-gradient-to-r from-black/20 via-black/10 to-transparent -z-10"></div>

//       {/* ===== Content ===== */}
//       <div className="relative z-10 w-full px-6 sm:px-10 lg:px-20 py-20">
//         <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

//           {/* ===== Left Content ===== */}
//           <div className="text-white space-y-6">

//             <div className="inline-flex items-center bg-white/10 border border-white/20 px-4 py-2 rounded-full backdrop-blur">
//               <span className="text-sm font-semibold tracking-wide text-orange-400">
//                 Enterprise Bulk SMS Platform
//               </span>
//             </div>

//             <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
//               Reliable Bulk SMS Solutions
//               <br />
//               <span className="text-orange-400">
//                 Built for Business Growth
//               </span>
//             </h1>

//             <p className="text-lg text-gray-200 max-w-2xl leading-relaxed">
//               Deliver time-critical messages with high throughput, secure routing,
//               and real-time delivery insights. Trusted by businesses for
//               promotional, transactional, and OTP messaging.
//             </p>

//             {/* ===== CTA Row ===== */}
//             <div className="flex flex-col sm:flex-row items-start sm:items-center gap-8 pt-6">

//               <button
//                 onClick={handleSignupClick}
//                 className="px-6 py-3 bg-white  text-[#0C4550] font-semibold rounded-lg shadow-xl transition-all duration-300 transform hover:scale-105"
//               >
// Signup Now              </button>

//               <div className="flex items-center gap-3">
//                 <FiPhone className="text-orange-400 text-2xl" />
//                 <div>
//                   <p className="text-sm text-gray-300">Sales Enquiry</p>
//                   <a
//                     href="tel:+919717055088"
//                     className="text-lg font-semibold text-white transition"
//                   >
//                     +91-9717055088
//                   </a>
//                 </div>
//               </div>

//             </div>
//           </div>

//           {/* ===== Right Spacer (kept empty for premium layout balance) ===== */}
//           <div className="hidden lg:block"></div>

//         </div>
//       </div>

//       {/* ===== Animation Styles ===== */}
//       <style>
//         {`
//           @keyframes slowZoom {
//             0% { transform: scale(1.1); }
//             100% { transform: scale(1.18); }
//           }

//           .animate-slow-zoom {
//             animation: slowZoom 20s ease-in-out infinite alternate;
//           }
//         `}
//       </style>
//     </section>
//   );
// };

// export default HeroSection;





import React from "react";
import { FiPhone } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion"; // Import Framer Motion
import FrontImage from "../assets/Homepic.webp"

const HeroSection = () => {
  const navigate = useNavigate();

  const handleSignupClick = () => {
    navigate("/login?mode=signup");
  };

  // Animation Variants for a "Premium" Staggered feel
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, // Delay between each item appearing
        delayChildren: 0.3,   // Initial delay after page load
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 }, // Start slightly lower
    visible: {
      opacity: 1,
      y: 0,
      transition: { 
        duration: 0.8, 
        ease: [0.25, 0.1, 0.25, 1.0] // Cubic-bezier for a silky smooth stop
      },
    },
  };

  return (
    <section className="relative min-h-[90vh] w-full overflow-hidden flex items-center">
      
      {/* ===== Background Image (Unchanged) ===== */}
      <div className="absolute inset-0 -z-20">
        <img
          src={FrontImage}
          alt="Bulk SMS Platform Background"
          className="w-full h-full object-cover scale-110 animate-slow-zoom" // Added the animation class you defined below
        />
      </div>

      {/* ===== Dark Overlay ===== */}
      <div className="absolute inset-0 bg-black/45 -z-10"></div>

      {/* ===== Gradient Overlay ===== */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/10 to-transparent -z-10"></div>

      {/* ===== Content ===== */}
      <div className="relative z-10 w-full px-6 sm:px-10 lg:px-20 py-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* ===== Left Content (Animated) ===== */}
          <motion.div 
            className="text-white space-y-6"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >

            {/* 1. Badge */}
            <motion.div variants={itemVariants} className="inline-flex items-center bg-white/10 border border-white/20 px-4 py-2 rounded-full backdrop-blur">
              <span className="text-sm font-semibold tracking-wide text-orange-400">
                Enterprise Bulk SMS Platform
              </span>
            </motion.div>

            {/* 2. Heading */}
            <motion.h1 variants={itemVariants} className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
              Reliable Bulk SMS Solutions
              <br />
              <span className="text-orange-400">
                Built for Business Growth
              </span>
            </motion.h1>

            {/* 3. Description */}
            <motion.p variants={itemVariants} className="text-lg text-gray-200 max-w-2xl leading-relaxed">
              Deliver time-critical messages with high throughput, secure routing,
              and real-time delivery insights. Trusted by businesses for
              promotional, transactional, and OTP messaging.
            </motion.p>

            {/* 4. CTA Row */}
            <motion.div variants={itemVariants} className="flex flex-col sm:flex-row items-start sm:items-center gap-8 pt-6">

              <button
                onClick={handleSignupClick}
                className="px-6 py-3 bg-white text-[#0C4550] font-semibold rounded-lg shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                Signup Now
              </button>

              <div className="flex items-center gap-3">
                <FiPhone className="text-orange-400 text-2xl" />
                <div>
                  <p className="text-sm text-gray-300">Sales Enquiry</p>
                  <a
                    href="tel:+919717055088"
                    className="text-lg font-semibold text-white "
                  >
                    +91-9717055088
                  </a>
                </div>
              </div>

            </motion.div>
          </motion.div>

          {/* ===== Right Spacer (kept empty) ===== */}
          <div className="hidden lg:block"></div>

        </div>
      </div>

      {/* ===== Animation Styles ===== */}
      <style>
        {`
          @keyframes slowZoom {
            0% { transform: scale(1.1); }
            100% { transform: scale(1.18); }
          }

          .animate-slow-zoom {
            animation: slowZoom 20s ease-in-out infinite alternate;
          }
        `}
      </style>
    </section>
  );
};

export default HeroSection;

